export default class Selected {
    constructor() {
        this.list = new Set();
    }

    get count() {
        return this.list.size;
    }

    add(item) {
        let added;
        if (this.has(item)) {
            added = this.remove(item);
        } else {
            added = this.list.add(item);
        }
        return added;
    }

    remove(item) {
        return this.list.delete(item);
    }

    has(item) {
        return this.list.has(item);
    }

    keys() {
        return this.list.keys();
    }

    values() {
        return this.list.entries();
    }

    toArray() {
        return Array.from(this.list);
    }
}
